<template>
  <div class="home">
    <HomeHeader class="home-header"></HomeHeader>
    <HomeNav class="home-nav"></HomeNav>
    <!--<HomeSwiper></HomeSwiper>-->
    <div class="join">
      <Fold :list="foldList"></Fold>
      <transition name="fade" mode="out-in">
        <router-view class="right"/>
      </transition>
    </div>
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import HomeHeader from '../../common/header/Header'
import HomeNav from '../../common/navigation/Navigation'
import HomeSwiper from '../home/components/Swiper'
import Fold from './components/Fold'
import HomeFooter from '../../common/footer/Footer'
import foldList from '../../assets/js/fold'
export default {
  name: 'home',
  components: {
    HomeHeader, HomeNav, HomeSwiper, Fold, HomeFooter
  },
  data () {
    return {
      foldList: foldList.join,
      screenWidth: document.body.clientWidth
    }
  },
  methods: {
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        this.$router.go(0)
      })()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .home
    position relative
    .home-nav
      position absolute
      top 150px
      left 0
      z-index 2
      width 100%
    .home-poster
      position relative
  .join
    flexBetween()
    mt50()
    padding 70px 18.75% 0
    background #fff
    overflow hidden
    .right
      font-size 15px
      font-family "Helvetica Neue"
      line-height 28px
</style>



// WEBPACK FOOTER //
// src/pages/contact/Contact.vue